import { render, staticRenderFns } from "./bigQuiz.vue?vue&type=template&id=803bc758&"
import script from "./bigQuiz.vue?vue&type=script&lang=js&"
export * from "./bigQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports